module.exports = __webpack_public_path__ + "96520ca436426f6462e87ca730e613b6.pdf";